import { combineReducers } from '@reduxjs/toolkit';
import createNewsReducer from './create/createSlice';
import newsListReducer from './list/listSlice';
import deleteNewsReducer from './delete/deleteSlice';

const newsSlice = combineReducers({
    create: createNewsReducer,
    list: newsListReducer,
    delete: deleteNewsReducer,
});

export default newsSlice;
